<div class="popup">
    <div class="modal-header">
        <div class="modal-headerTitle" style="padding-left:10px;padding-top:10px; color:red; width:100%;font-size:15px;font-weight:bold;" translate>
            <span>You are not the primary teacher for this class.</span>
        </div>
    </div>
    <div class="modal-body" style="padding:10px;margin-bottom:70px;">
        Only the primary teacher is allowed to make changes to the preferences for a class.
    </div>    
    <div class="sis-app-footer">
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</div>
